import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const prescriptionLocaleModule: LocaleModule = {
  name: "prescription",
  messages: { en: en, it: it },
};
